import { MspCodesEnum } from '../enums/MspCodesEnum';

export const mspCategoryTitlesByMspCodes: Record<MspCodesEnum, string> = {
  [MspCodesEnum.NON_EXIST]: 'Не является субъектом МСП',
  [MspCodesEnum.MICRO]: 'Микропредприятие',
  [MspCodesEnum.SMALL]: 'Малое предприятие',
  [MspCodesEnum.NORMAL]: 'Среднее предприятие',
};
